import a from '@/services/base/config'
const request = async (url: string, method: string, data: any, config?: { [key: string]: any }) => {
  const result: any = {}
  try {
    const response = await a({
      url,
      method,
      data,
      headers: {
        'Cache-Control': 'no-store'
      },
      ...config
    } as any)
    result.success = true
    result.data = response.data
    result.status = response.status
  } catch (error: any) {
    // Ответа может не быть вовсе: обрыв сети, таймаут, отменённый запрос, а также уход страницы
    // на перезагрузку при смене активного профиля. Раньше обращение к `error.response.status`
    // роняло сам обработчик ошибки — наружу летел TypeError вместо `{ success: false }`, и
    // вызывающий код (все экраны кабинета) не показывал пользователю ничего осмысленного.
    result.status = error.response?.status ?? 0
    result.success = false
    if (error) {
      if (error.response?.data) {
        result.data = error.response.data
      } else {
        result.data = {}
      }
    } else {
      result.data = {}
    }
  }
  return result
}

export default request
